import { useCallback, useState } from "react";
import { API_ROUTES } from "../../api/routes";
import { GameClient } from "../../api/GameClient";
import { GameState } from "../../types/GameState";
import { AxiosError } from "axios";
import { User } from "../../types/Session";

export const useJoinGame = () => {
  const [loading, setLoading] = useState(false);
  const [game, setGame] = useState<GameState>();
  const [error, setError] = useState<AxiosError>();

  const joinGame = useCallback(
    async (code: string, user: Partial<User>, password: string) => {
      setError(undefined);
      setLoading(true);
      try {
        const { data } = await GameClient.post(API_ROUTES.JOIN(code), {
          ...user,
          password,
        });
        if (data) {
          setGame(data);
          setLoading(false);
          return data;
        }
      } catch (e) {
        setLoading(false);
        const error = e as AxiosError<any, any>;
        error.message = error.response?.data?.message || error.message;
        setError(e as any);
      }
    },
    []
  );

  return { game, joinGame, loading, error };
};
